export const alarmSelector = (state) => state.config.alarm;
export const siteConfigSelector = (state) => state.config.siteConfig;
